import { Protect } from '@clerk/clerk-react';
import { useParams } from 'react-router-dom';
import { ChartPieIcon } from '@heroicons/react/20/solid';

import { useChannel } from '@services/channels';
import { useShop } from '@services/ShopProvider';
import Sidebar from '@components/Sidebar';
import OnboardingAccessControl from '@components/OnboardingAccessControl';
import HideForLocalFeedPartner from '@utils/HideForLocalFeedPartner';

const Insights = () => {
	const { shop, data: shops } = useShop();
	const { shopId } = useParams();
	const { data: prodLocConfig } = useChannel('product-locator');
	const { data: googleChannel } = useChannel('google');
	const googleEnabled = googleChannel.status === 'enabled';
	const shopSelected = shopId;
	const onFreemium = shopSelected ? shop.plan === 'freemium' : shops.every((shop) => shop.plan === 'freemium');
	const liaAvailable = shopSelected ? shop.availableChannels?.['local-ads'] : shops.some((shop) => shop.availableChannels?.['local-ads']);
	const productLocatorAvailable = Boolean(shops.some((shop) => shop.availableChannels?.['product-locator']) && prodLocConfig?.status === 'enabled');

	return (
		<Sidebar.Menu>
			<OnboardingAccessControl allowedState={'shop.google.pos-link-ok'}>
				{googleEnabled && (
					<Protect permission="org:insights:read">
						<Sidebar.Item to="/insights/overview" activePaths={['/insights']}>
							<ChartPieIcon />
							Insights
						</Sidebar.Item>
						<Sidebar.SubMenu prefix="/insights">
							<Sidebar.SubItem to="/insights/overview">Overview</Sidebar.SubItem>
							<HideForLocalFeedPartner>
								<Sidebar.SubItem to="/insights/local-listings">Local Listings</Sidebar.SubItem>
							</HideForLocalFeedPartner>
							{!onFreemium && liaAvailable && <Sidebar.SubItem to="/insights/local-ads">Local Ads</Sidebar.SubItem>}
							{productLocatorAvailable && <Sidebar.SubItem to="/insights/product-locator">Product Locator</Sidebar.SubItem>}
							<Sidebar.SubItem to="/insights/business-profile">Google Business Profile</Sidebar.SubItem>
						</Sidebar.SubMenu>
					</Protect>
				)}
			</OnboardingAccessControl>
		</Sidebar.Menu>
	);
};

export default Insights;
